import React, { useEffect } from 'react'
import WOW from 'wowjs';

function BannerThree() {
    useEffect(() => {
        const wow = new WOW.WOW();
        wow.init();
    }, []);
    return (
        <>
            {/* Banner area Start */}
            <section id="home" className="rts-banner-area area-three">
                <div className="container">
                    <div className="section-inner">
                        <div className="banner-hero">
                            <img
                                className="wow scaleIn"
                                data-wow-delay=".8s"
                                data-wow-duration="1.5s"
                                src="assets/images/banner/banner-hero-03.svg"
                                width={359}
                                alt=""
                            />
                            <img
                                className="wow scaleIn"
                                data-wow-delay=".8s"
                                data-wow-duration="1.5s"
                                src="assets/images/banner/banner-hero-04.svg"
                                width={466}
                                alt=""
                            />
                        </div>
                        <div className="row justify-content-center">
                            <div className="col-lg-7">
                                <div className="banner-wrapper-one">
                                    <div className="section-title-area2">
                                        <p
                                            className="sub-title wow fadeInUp"
                                            data-wow-delay=".2s"
                                            data-wow-duration="2s"
                                        >
                                            Laugh Out Loud, Share the Joy
                                        </p>
                                        <h1
                                            className="section-title wow fadeInUp"
                                            data-wow-delay=".5s"
                                            data-wow-duration="2s"
                                        >
                                            Discover What Makes Us Special
                                        </h1>
                                    </div>
                                    <p
                                        className="desc text-center wow fadeInUp"
                                        data-wow-delay=".8s"
                                        data-wow-duration="2s"
                                    >
                                        Dive into a world where creativity meets humor, and every click
                                        brings a smile. With our easy-to-use meme creator, you can
                                        design hilarious memes.
                                    </p>
                                    <div
                                        className="button-area d-flex align-items-center justify-content-center wow fadeInUp"
                                        data-wow-delay="1.1s"
                                        data-wow-duration="2s"
                                    >
                                        <div className="button with-after2">
                                            <a href="#" className="rts-btn btn-primary">
                                                Start Creating
                                            </a>
                                        </div>
                                        <div className="button with-after2">
                                            <a href="#" className="rts-btn btn-primary bg-white">
                                                Explore Memes
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="shape-area">
                    <img
                        className="wow fadeIn"
                        data-wow-delay="1s"
                        data-wow-duration="2s"
                        src="assets/images/banner/coin-01.svg"
                        width={63}
                        alt=""
                    />
                    <img
                        className="wow fadeIn"
                        data-wow-delay="1s"
                        data-wow-duration="2s"
                        src="assets/images/banner/coin-01.svg"
                        width={63}
                        alt=""
                    />
                    <img
                        className="wow fadeIn"
                        data-wow-delay="1s"
                        data-wow-duration="2s"
                        src="assets/images/banner/coin-01.svg"
                        width={47}
                        alt=""
                    />
                </div>
            </section>
            {/* Banner area end */}
        </>

    )
}

export default BannerThree